
































import { Component, Vue } from "vue-property-decorator";
import { ISideMenuItem } from "@/models/menus/abstract/isidemenu";

@Component
export default class AccountLayoutPage extends Vue {
  menu: ISideMenuItem[] = [
    { icon: "las la-id-badge", title: "Perfil", url: "profile" },
    { icon: "las la-lock", title: "Segurança", url: "security" }
    // { icon: "las la-history", title: "Histórico", url: "history" }
  ];
}
